import {Component, OnInit} from '@angular/core';
import {ProfileService} from '../../../../services/profile.service';
import {Profile} from '../../../../model/profile';
import {Observable} from 'rxjs';
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {DashBlockComponent} from "../dash-block.component";
import { CommonModule, NgOptimizedImage } from "@angular/common";
import {SpinnerComponent} from "../../../common/spinner/spinner.component";
import {DynamicModalFormComponent} from "../../../common/dynamic-modal-form/dynamic-modal-form.component";
import {UserFavoriteFormGeneratorService} from "../../../../formulaires/user/user-favorite-form-generator.service";
import {ToastrService} from "ngx-toastr";

@Component({
    selector: 'app-dash-block-favorites',
    templateUrl: './dash-block-favorites.component.html',
    imports: [
        CommonModule,
        FaIconComponent,
        SpinnerComponent,
        DashBlockComponent,
        DynamicModalFormComponent,
        NgOptimizedImage
    ],
    styleUrls: ['./dash-block-favorites.component.css']
})
export class DashBlockFavoritesComponent implements OnInit {

  // Flag to control modal
  addingFavorite: boolean;
  profile: Observable<Profile>;

  constructor(private profileService: ProfileService,
              public userFavoriteFormGeneratorService: UserFavoriteFormGeneratorService,
              private toastr: ToastrService) {
  }

  ngOnInit(): void {
    this.profile = this.profileService.getProfile();
  }

  getDomainFromUrl(url): string {
    const a = document.createElement('a');
    a.href = url;
    return a.hostname;
  }

  onSubmit(event: any): void {
    this.profileService.addFavorite(event);
    this.addingFavorite = undefined;
    this.toastr.success('Favori sauvegardé');
  }

  removeFavorite(fav, event): void {
    this.profileService.removeFavorite(fav);
    event.stopPropagation();
    event.preventDefault();
    event.stopImmediatePropagation();
    this.toastr.error('Favori supprimé');
  }

}
